/* eslint-disable id-length */
/* eslint-disable camelcase */
ACC.googleanalytics = {
  gaProductdetailpage: function(productId) {
    var pricePdp = '',
        eddlAction = '';

    if (window.eddlContext.locale.currency === 'THB') {
      pricePdp = $('.ph-pdpprice-value').text().replace(/,/g, '');
    } else {
      pricePdp = $('.ph-pdpprice-value').text().replace(/,(?=[^,]*$)/, '.');
    }

    eddlAction = {
      trigger: 'ecommerce.product.detail',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        detail: {
          products: [
            {
              id: productId,
              locale: window.eddlContext.locale.code,
              price: parseFloat(pricePdp.replace(/[^\d.-]/g, ''))
            }
          ]
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaAddtocart: function(list, products) {
    var eddlAction = {
      trigger: 'ecommerce.cart.add',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        add: {
          actionField: {
            list: list
          },
          products: products
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  createProductListForGa: function(productId, qty, price) {
    var finalPrice = price.replace(/[^\d.-]/g, ''),
        listItem = {
          id: productId,
          locale: window.eddlContext.locale.code,
          quantity: qty,
          price: parseFloat(finalPrice)
        };


    return listItem;
  },
  createUserEventForGa: function(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  },
  trackCartViewGoogleAnalytics: function(eventType) {
    var eddlAction = {};


    eddlAction = ACC.googleanalytics.eddlActionObj(eventType);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  eddlActionObj: function(eventType) {
    return {
      trigger: eventType,
      event: 'ecommerceEvent',
      ecommerce: window.eddlContext.ecommerce
    };
  },
  gaEventsForLinks: function(userEventObj) {
    var eddlAction = {
      trigger: userEventObj.trigger,
      event: 'userEvent',
      interaction: {
        goal: 'link',
        description: userEventObj.description,
        url: userEventObj.url,
        interactive: true
      },
      component: {
        name: userEventObj.compname,
        type: 'link'
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaForSuccessFail: function(statusObj) {
    var eddlAction = {
      trigger: statusObj.triggerValue,
      event: 'userEvent',
      interaction: {
        goal: statusObj.componentName,
        description: statusObj.description,
        value: statusObj.value,
        status: statusObj.status,
        interactive: true
      },
      component: {
        name: statusObj.componentName,
        type: 'button'
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaForSearch: function(searchObj) {
    var eddlAction = {
      trigger: searchObj.componentName + '.searchResults',
      event: 'userEvent',
      interaction: {
        goal: 'search_results',
        description: searchObj.description,
        value: searchObj.value,
        status: searchObj.status,
        interactive: true
      },
      component: {
        name: searchObj.componentName,
        type: 'search'
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaEventsForEcommerce: function(productsArray, trigger) {
    var eddlAction = {
      trigger: trigger,
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        purchase: {
          products: productsArray
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaEventForCancelOrder: function(products, orderCode) {
    var eddlAction = {
      trigger: 'ecommerce.checkout.refund',
      event: 'ecommerceEvent',
      interaction: {
        goal: 'Cancel order'
      },
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        refund: {
          actionField: {
            id: orderCode
          },
          products: products
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaEventsForReturnOrder: function(ecommerceEventObj, productsArray) {
    var eddlAction = {
      trigger: ecommerceEventObj.trigger,
      event: 'ecommerceEvent',
      interaction: {
        goal: 'refund',
        refund: {
          returnId: ecommerceEventObj.returnId,
          returnReason: ecommerceEventObj.returnReason
        }
      },
      ecommerce: {
        currencyCode: window.eddlContext.locale.currency,
        refund: {
          actionField: {
            id: ecommerceEventObj.orginalOrdId
          },
          products: productsArray
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },
  gaEventsForReportOrder: function(userEventObj) {
    var eddlAction = {
      trigger: userEventObj.componentName + '.submit',
      event: 'userEvent',
      interaction: {
        goal: 'Order Issue complain',
        description: userEventObj.reasonCode,
        status: userEventObj.status,
        url: userEventObj.url,
        interactive: true,
        id: userEventObj.orderCode,
        value: userEventObj.claimDescription
      },
      form: {
        type: 'Submit'
      },
      component: {
        name: userEventObj.componentName,
        type: 'form',
        instance: '1',
        element: userEventObj.eventbtnname,
        id: userEventObj.formid
      }
    };

    window.eddlEvents = window.eddlEvents || [];

    window.eddlEvents.push(eddlAction);
  },
  gaEventForCheckoutStepOption: function(paymentStep, paymentOption) {
    var eddlAction = {
      trigger: 'ecommerce.checkout.step.option',
      event: 'ecommerceEvent',
      marketPlaceParticipant: 'complete-order',
      ecommerce: {
        checkout_option: {
          actionField: {
            step: paymentStep,
            option: paymentOption
          }
        }
      }
    };

    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  }

};
/* eslint-enable id-length */
/* eslint-enable camelcase */
